const validUtil = {
    checkEmailValidation:checkEmailValidation
}

function checkEmailValidation(text:string) {
    const isValid = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(text);
    console.log('isValid', isValid)
    return !isValid;             
};

export { validUtil };